enum FileAccessRequirements {
  Public = 0,
  FreeTrial = 1,
  ActiveSubscription = 2,
}

export default FileAccessRequirements;
